import {
  CustomFieldSchema,
  CustomFieldType,
  CustomFieldValidators,
  TextTypeOptions,
} from '@tribeplatform/gql-client/types'

import {
  CustomFieldSubtype,
  CustomFieldValidatorPattern,
} from '../../CustomField/utils'

export const suggestedFields: CustomFieldSchema[] = [
  {
    name: 'Website',
    key: 'website',
    type: CustomFieldType.TEXT,
    settings: [
      { key: 'subtype', value: JSON.stringify(CustomFieldSubtype.URL) },
    ],
    validators: [
      {
        validation: CustomFieldValidators.PATTERN,
        value: JSON.stringify(CustomFieldValidatorPattern.URL),
        customErrorMessage: 'Website link should start with https://',
      },
    ],
  },
  {
    name: 'Birthday',
    key: 'birthday',
    type: CustomFieldType.DATE,
  },
  {
    name: 'Job title',
    key: 'jobTitle',
    type: CustomFieldType.TEXT,
  },
  {
    name: 'Pronoun',
    key: 'pronoun',
    type: CustomFieldType.TEXT,
    typeOptions: { textType: TextTypeOptions.SHORT_TEXT },
    settings: [
      { key: 'subtype', value: JSON.stringify(CustomFieldSubtype.SELECT) },
    ],
    validators: [
      {
        validation: CustomFieldValidators.ENUM,
        value: JSON.stringify(['She/Her', 'He/Him', 'They/Them']),
      },
    ],
  },
  {
    name: 'Featured',
    key: 'featured',
    type: CustomFieldType.BOOLEAN,
  },
  {
    name: 'Company',
    key: 'company',
    type: CustomFieldType.TEXT,
  },
  {
    name: 'Location',
    key: 'location',
    type: CustomFieldType.TEXT,
  },
  {
    name: 'Country',
    key: 'country',
    type: CustomFieldType.TEXT,
    settings: [
      { key: 'inputComponent', value: JSON.stringify('CountryPicker') },
    ],
  },
  {
    name: 'City',
    key: 'city',
    type: CustomFieldType.TEXT,
  },
  {
    name: 'Gender',
    key: 'gender',
    type: CustomFieldType.TEXT,
    settings: [
      { key: 'subtype', value: JSON.stringify(CustomFieldSubtype.SELECT) },
    ],
    validators: [
      {
        validation: CustomFieldValidators.ENUM,
        value: JSON.stringify(['Male', 'Female', 'Other']),
      },
    ],
  },
  ...[
    {
      name: 'Twitter',
      key: 'twitter',
      regex: CustomFieldValidatorPattern.TWITTER_PROFILE,
      placeholder: 'https://twitter.com/username',
    },
    {
      name: 'Instagram',
      key: 'instagram',
      regex: CustomFieldValidatorPattern.INSTAGRAM_PROFILE,
      placeholder: 'https://instagram.com/username',
    },
    {
      name: 'Facebook',
      key: 'facebook',
      regex: CustomFieldValidatorPattern.FACEBOOK_PROFILE,
      placeholder: 'https://facebook.com/username',
    },
    {
      name: 'Youtube channel',
      key: 'youtubeChannel',
      icon: 'youtube',
      regex: CustomFieldValidatorPattern.YOUTUBE_CHANNEL,
      placeholder: 'https://youtube.com/channel/abcdefg',
    },
    {
      name: 'LinkedIn',
      key: 'linkedin',
      regex: CustomFieldValidatorPattern.LINKEDIN_PROFILE,
      placeholder: 'https://linkedin.com/in/username',
    },
    {
      name: 'Github',
      key: 'github',
      regex: CustomFieldValidatorPattern.GITHUB_PROFILE,
      placeholder: 'https://github.com/username',
    },
    {
      name: 'Telegram',
      key: 'telegram',
      regex: CustomFieldValidatorPattern.TELEGRAM_PROFILE,
      placeholder: 'https://t.me/username',
    },
    {
      name: 'Snapchat',
      key: 'snapchat',
      regex: CustomFieldValidatorPattern.SNAPCHAT_PROFILE,
      placeholder: 'https://snapchat.com/add/username',
    },
    {
      name: 'Medium',
      key: 'medium',
      regex: CustomFieldValidatorPattern.MEDIUM_PROFILE,
      placeholder: 'https://medium.com/@username',
    },
    {
      name: 'Reddit',
      key: 'reddit',
      regex: CustomFieldValidatorPattern.REDDIT_PROFILE,
      placeholder: 'https://reddit.com/user/username',
    },
    {
      name: 'Stack Overflow',
      key: 'stackoverflow',
      regex: CustomFieldValidatorPattern.STACKOVERFLOW_PROFILE,
      placeholder: 'https://stackoverflow.com/users/123/username',
    },
  ].map(({ icon, name, key, regex, placeholder }) => ({
    name,
    key,
    type: CustomFieldType.TEXT,
    settings: [
      { key: 'subtype', value: JSON.stringify(CustomFieldSubtype.URL) },
      {
        key: 'placeholder',
        value: JSON.stringify(placeholder),
      },
      { key: 'viewComponent', value: JSON.stringify('SocialMedia') },
      { key: 'icon', value: JSON.stringify(icon || key) },
      { key: 'section', value: JSON.stringify('Social links') },
      { key: 'category', value: JSON.stringify('socialLink') },
      { key: 'locked', value: JSON.stringify(true) },
    ],
    validators: [
      {
        validation: CustomFieldValidators.PATTERN,
        value: JSON.stringify(regex),
        customErrorMessage: `Please enter a valid ${name} link`,
      },
    ],
  })),
]
